export async function drawOutputImage(stage: any, outputStage: any, watermarkSettings?: any) {
    const layers = outputStage.children
    const drawingRawLayer = stage.children[0]  // 消しゴムレイヤー
    const drawingRawImageData = getLayerImageData(drawingRawLayer)
    const drawingLayer = layers[0]
    await drawScaledImageToLayer(drawingLayer, drawingRawImageData)
    const drawingImageData = getLayerImageData(drawingLayer)

    const aiEraserRawLayer = stage.children[1]  // AI消しゴムレイヤー
    const aiEraserRawImageData = getLayerImageData(aiEraserRawLayer)
    const aiEraserLayer = layers[1]
    await drawScaledImageToLayer(aiEraserLayer, aiEraserRawImageData)
    const aiEraserImageData = getLayerImageData(aiEraserLayer)

    const beforeImageLayer = layers[2]  // インデックス修正: 1 → 2
    const beforeImageData = getLayerImageData(beforeImageLayer)
    const afterImageLayer = layers[3]  // インデックス修正: 2 → 3
    const afterImageData = getLayerImageData(afterImageLayer)

    const outputLayer = layers[4]  // インデックス修正: 3 → 4
    let mergedImageData = mergeImageData(outputLayer, beforeImageData, afterImageData, drawingImageData)

    // AI消しゴムレイヤーを上に重ねる
    mergedImageData = mergeAIEraserData(mergedImageData, aiEraserImageData)

    // ウォーターマークレイヤーが存在し、ウォーターマーク設定が有効な場合のみ合成
    if (layers[5] && watermarkSettings) {  // インデックス修正: 4 → 5
        const { isWatermarkEnabled } = require('../utils/watermark')
        if (isWatermarkEnabled(watermarkSettings)) {
            const watermarkImageData = getLayerImageData(layers[5])  // インデックス修正: 4 → 5
            mergedImageData = mergeWatermarkData(mergedImageData, watermarkImageData)
        }
    }
    
    drawLayerImage(outputLayer, mergedImageData)
}

export function drawPreviewImage(stage: any, previewCanvas: any, mouseX = null, mouseY = null, watermarkLayerRef: any = null) {
    if (!stage) return
    const layers = stage.children
    if (!layers || layers.length == 0) return

    const drawingLayer = layers[0]  // 消しゴムレイヤー
    const drawingImageData = getLayerImageData(drawingLayer)

    const aiEraserLayer = layers[1]  // AI消しゴムレイヤー
    if (!aiEraserLayer) return

    const aiEraserImageData = getLayerImageData(aiEraserLayer)
    if (!aiEraserImageData) return

    const beforeImageLayer = layers[2]  // インデックス修正: 1 → 2
    const beforeImageData = getLayerImageData(beforeImageLayer)
    const afterImageLayer = layers[3]  // インデックス修正: 2 → 3
    const afterImageData = getLayerImageData(afterImageLayer)
    const outputLayer = layers[4]  // インデックス修正: 3 → 4

    if (!beforeImageData || !afterImageData) return

    // 画像データが空（全て透明）の場合は描画しない（Konvaがまだ画像を描画していない可能性）
    // これにより、非同期処理中に真っ白になる問題を防ぐ
    if (!hasVisiblePixels(afterImageData)) {
        console.warn('drawPreviewImage: afterImageData is empty, skipping draw')
        return
    }

    let mergedImageData = mergeImageData(outputLayer, beforeImageData, afterImageData, drawingImageData)

    // AI消しゴムレイヤーを上に重ねる
    mergedImageData = mergeAIEraserData(mergedImageData, aiEraserImageData)
    
    // ウォーターマークレイヤーが存在する場合のみ合成（既にisWatermarkEnabledチェック済み）
    if (watermarkLayerRef && layers[5]) {  // インデックス修正: 4 → 5
        const watermarkImageData = getLayerImageData(layers[5])  // インデックス修正: 4 → 5
        mergedImageData = mergeWatermarkData(mergedImageData, watermarkImageData)
    }
    
    drawCanvasImage(previewCanvas, mergedImageData, mouseX, mouseY)
}

function mergeAIEraserData(baseImageData: any, aiEraserImageData: any) {
    // AI消しゴムの赤色を基本画像に合成
    for (let i = 0; i < baseImageData.data.length; i += 4) {
        // AI消しゴムレイヤーのアルファ値が0より大きい場合、赤色を合成
        if (aiEraserImageData.data[i + 3] > 0) {
            const alpha = aiEraserImageData.data[i + 3] / 255
            const invAlpha = 1 - alpha

            // アルファブレンディング
            baseImageData.data[i + 0] = baseImageData.data[i + 0] * invAlpha + aiEraserImageData.data[i + 0] * alpha
            baseImageData.data[i + 1] = baseImageData.data[i + 1] * invAlpha + aiEraserImageData.data[i + 1] * alpha
            baseImageData.data[i + 2] = baseImageData.data[i + 2] * invAlpha + aiEraserImageData.data[i + 2] * alpha
        }
    }
    return baseImageData
}

function mergeWatermarkData(baseImageData: any, watermarkImageData: any) {
    // ウォーターマークを基本画像に合成
    for (let i = 0; i < baseImageData.data.length; i += 4) {
        // ウォーターマークのアルファ値が0より大きい場合、ピクセルを合成
        if (watermarkImageData.data[i + 3] > 0) {
            const alpha = watermarkImageData.data[i + 3] / 255
            const invAlpha = 1 - alpha
            
            // アルファブレンディング
            baseImageData.data[i + 0] = baseImageData.data[i + 0] * invAlpha + watermarkImageData.data[i + 0] * alpha
            baseImageData.data[i + 1] = baseImageData.data[i + 1] * invAlpha + watermarkImageData.data[i + 1] * alpha
            baseImageData.data[i + 2] = baseImageData.data[i + 2] * invAlpha + watermarkImageData.data[i + 2] * alpha
        }
    }
    return baseImageData
}

function mergeImageData(outputLayer: any, beforeImageData: any, afterImageData: any, drawingImageData: any) {
    let outputImageData = getLayerBlankImageData(outputLayer)

    for (let i = 0; i < outputImageData.data.length; i += 4) {
        // Modify pixel data
        if (drawingImageData.data[i + 3] == 0) {
            outputImageData.data[i + 0] = afterImageData.data[i + 0]; // R value
            outputImageData.data[i + 1] = afterImageData.data[i + 1]; // G value
            outputImageData.data[i + 2] = afterImageData.data[i + 2]; // B value
            outputImageData.data[i + 3] = afterImageData.data[i + 3]; // A value
        } else {
            outputImageData.data[i + 0] = beforeImageData.data[i + 0]; // R value
            outputImageData.data[i + 1] = beforeImageData.data[i + 1]; // G value
            outputImageData.data[i + 2] = beforeImageData.data[i + 2]; // B value
            outputImageData.data[i + 3] = beforeImageData.data[i + 3]; // A value
        }
    }

    return outputImageData
}

async function drawScaledImageToLayer(layer: any, imageData: any) {
    const canvas = layer.getCanvas()
    const context = canvas.getContext()
    context.imageSmoothingEnabled = false; // keep pixel perfect
    const bitmap = await createImageBitmap(imageData)
    context.drawImage(bitmap, 0, 0, layer.width(), layer.height());
}

function getLayerImageData(layer: any) {
    if (!layer) return null
    const canv = layer.getCanvas()
    if (!canv) return null
    const context = canv.getContext()
    if (!context) return null
    return context.getImageData(0, 0, canv.width, canv.height)
}

/**
 * 画像データに表示可能なピクセル（アルファ値 > 0）があるかチェック
 * Konvaがまだ画像を描画していない場合、全ピクセルのアルファ値が0になる
 */
function hasVisiblePixels(imageData: ImageData): boolean {
    const data = imageData.data
    // サンプリングで高速チェック（全ピクセルチェックは遅いため）
    const step = Math.max(1, Math.floor(data.length / 4000)) * 4  // 約1000ピクセルをサンプリング
    for (let i = 3; i < data.length; i += step) {
        if (data[i] > 0) return true  // アルファ値が0より大きいピクセルがある
    }
    return false
}

function getLayerBlankImageData(layer: any) {
    const canv = layer.getCanvas() 
    const context = canv.getContext()
    return context.createImageData(canv.width, canv.height)
}

function drawLayerImage(layer: any, imageData: any) {
    const canvas = layer.getCanvas() 
    const context = canvas.getContext()
    context.putImageData(imageData, 0, 0);
}

async function drawCanvasImage(canvas: any, imageData: any, mouseX = null, mouseY = null) {
    const context = canvas.getContext('2d')
    const bitmap = await createImageBitmap(imageData)
    if (!mouseX || !mouseY) {
        context.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
        return
    }
    
    const WindowWidth = 200
    const scaleRatio = bitmap.width / canvas.width
    const left = Math.floor(mouseX) - WindowWidth/2
    const top = Math.floor(mouseY) - WindowWidth/2
    context.drawImage(bitmap, left*scaleRatio, top*scaleRatio, WindowWidth*scaleRatio, WindowWidth*scaleRatio, left, top, WindowWidth, WindowWidth)
}